import { useMemo } from "react";
import { format } from "date-fns";
import { apiGet } from "../utils/apiClient";

/**
 * Retrieves FixedRouteBusBlocks data.
 * @returns - A promise that resolves to the FixedRouteBusBlocks data.
 */
export const useFetchFixedRouteBusBlocks = () => {
  const memoizedFetchFixedRouteBusBlocks = useMemo(
    () => async (assignmentDate, rowFilter, pulloutDivision) => {
      const apiDate = format(assignmentDate, "dd-MMM-yyyy");
      return apiGet(
        `/FixedRouteBusBlocks/${apiDate}/${rowFilter}/${pulloutDivision}`,
        "fetching Fixed Route Bus Blocks"
      );
    },
    []
  );

  return memoizedFetchFixedRouteBusBlocks;
};
